import { isCanlan } from './customer-name'

/* Felipe Nunes: Updated Sat, 28 Mar 2026 22:35 PM ( CET ) */
// If it fails (like if the previously set hardcoded token is expired)
// try setting the hardcoded token again (hopefully a new one)
// {
//   "access_token": "v2.local.Q4O-hAkhPDmIlfdR5uxHyaQsNs8Y5Gc1H1kTjo55O96wKE-Z5RFhDsqLzjubrVBBX1bUExPgizarpm3sZ-8VYa0AK7rstNSiTWLl0VRrDQASLosXc6_sDaxxOtM8uPbUoQ1LWK4ogXGeCmumTqTbO3a1gaz6AkZIrPrlGW4Sn9ogQa6zsZe3rL74HmHj-riGuBW-O-2yGrLZpt1op1L_6e-F0EHZsiB4ugp_dwYIwF82xVzy_XCOyesPmV9hfR_JumXExoFHZRWa9PbkBjOwvmxt2nph7yiUVpkKB61DIQ0doLfrHOZvVKGY1gU4c0uXfcsJ3Ns1f7GcYYVxbI3LfIA2D38EenZgqw",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-08-20T23:34:56.103510Z",
//   "user": {
//     "id": "TAcc3KT6ikeaqhvL",
//     "email": "michael+planeticeservice@sportninja.com",
//     "account_id": null,
//     "created_at": "2022-08-29T23:14:34+00:00",
//     "updated_at": "2026-03-28T21:34:45+00:00",
//     "validated_at": "2022-08-29T23:14:42+00:00"
//   }
// }
const planetIceToken =
  'v2.local.Q4O-hAkhPDmIlfdR5uxHyaQsNs8Y5Gc1H1kTjo55O96wKE-Z5RFhDsqLzjubrVBBX1bUExPgizarpm3sZ-8VYa0AK7rstNSiTWLl0VRrDQASLosXc6_sDaxxOtM8uPbUoQ1LWK4ogXGeCmumTqTbO3a1gaz6AkZIrPrlGW4Sn9ogQa6zsZe3rL74HmHj-riGuBW-O-2yGrLZpt1op1L_6e-F0EHZsiB4ugp_dwYIwF82xVzy_XCOyesPmV9hfR_JumXExoFHZRWa9PbkBjOwvmxt2nph7yiUVpkKB61DIQ0doLfrHOZvVKGY1gU4c0uXfcsJ3Ns1f7GcYYVxbI3LfIA2D38EenZgqw'

// {
//   "access_token": "v2.local.TkD6sM2t9KwKJWoD-xspb2wNrwZxUATMjGxlS72vLpylWYEPSKkJ4LQ2_QOlH-P79L2sEnCKxKRM2Vz1IyVteB3hf7I0ZVJxQIxsgLYzknFcvbihxALWs7OZmuiIR_YZVFO4Bh-WRopqh0Ad7BB8GMQyZlomKh2d8QIaOY_wEmvJuMV7jPCJ5FdaDXJrz_JUcifMpKXl-mRjXBIDEQ3FSF4jvSDFW2irAj1QTVUTaPDSjQ7x_IIOqBlyyoQM-D2ub1zx4lWz5RIR-SSuVrmbn5CUVuT0NtqJ4GP3Z6FtLMmm6GJy6ifc9zeSGpXbSky7mfuxvk-OBSfMMzTGf3OkO9rK0lmb",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-08-20T23:34:56.416126Z",
//   "user": {
//     "id": "oP37ysYCd57bFlkj",
//     "email": "michael+carhaservice@sportninja.com",
//     "account_id": null,
//     "created_at": "2022-05-27T18:35:59+00:00",
//     "updated_at": "2026-03-28T21:36:19+00:00",
//     "validated_at": "2022-05-27T18:35:59+00:00"
//   }
// }
const carhaToken =
  'v2.local.TkD6sM2t9KwKJWoD-xspb2wNrwZxUATMjGxlS72vLpylWYEPSKkJ4LQ2_QOlH-P79L2sEnCKxKRM2Vz1IyVteB3hf7I0ZVJxQIxsgLYzknFcvbihxALWs7OZmuiIR_YZVFO4Bh-WRopqh0Ad7BB8GMQyZlomKh2d8QIaOY_wEmvJuMV7jPCJ5FdaDXJrz_JUcifMpKXl-mRjXBIDEQ3FSF4jvSDFW2irAj1QTVUTaPDSjQ7x_IIOqBlyyoQM-D2ub1zx4lWz5RIR-SSuVrmbn5CUVuT0NtqJ4GP3Z6FtLMmm6GJy6ifc9zeSGpXbSky7mfuxvk-OBSfMMzTGf3OkO9rK0lmb'

// {
//   "access_token": "v2.local.mjEQllz22HQLbUqkv_xanqOiRoAbbXxFXALD0VWOUUQcFyYV3EdcU8DaDJK58p6Qq6GzwSNaIJgO3q_rdZl47DcC4XLh2AP8Es3kTH6VDvGh4rMtWwmEnuunLkGyti_INHMRnB5DlBdowbAxR74YrsH2PDglyAcC88eGglJKKvT5mAQpf2pHd7q2mkEH8UdJTK6aLzlhrr1roX-78zZcyXNuN5smnBT04sDtUV5RGoEGM8qqxra0_MpQCGY31KO3Um4ipLrsS9f1fglA4d2xTxXGL_wkpWOB3UtnjmTsyy6BnPvLokXk2nVtVn_UFrq52b9pRI7jwV7Z2JgPRXqrrKIYW5E",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-08-20T23:34:56.763068Z",
//   "user": {
//     "id": "jJkc8qSsffa24rAE",
//     "email": "michael+canlanservice@sportninja.com",
//     "created_at": "2022-05-30T20:39:26+00:00",
//     "updated_at": "2023-05-19T19:59:44+00:00",
//     "validated_at": "2022-05-30T20:39:26+00:00"
//   }
// }
const canlanToken =
  'v2.local.mjEQllz22HQLbUqkv_xanqOiRoAbbXxFXALD0VWOUUQcFyYV3EdcU8DaDJK58p6Qq6GzwSNaIJgO3q_rdZl47DcC4XLh2AP8Es3kTH6VDvGh4rMtWwmEnuunLkGyti_INHMRnB5DlBdowbAxR74YrsH2PDglyAcC88eGglJKKvT5mAQpf2pHd7q2mkEH8UdJTK6aLzlhrr1roX-78zZcyXNuN5smnBT04sDtUV5RGoEGM8qqxra0_MpQCGY31KO3Um4ipLrsS9f1fglA4d2xTxXGL_wkpWOB3UtnjmTsyy6BnPvLokXk2nVtVn_UFrq52b9pRI7jwV7Z2JgPRXqrrKIYW5E'

export const getIframeToken = () => {
  const parentUrl =
    window.location !== window.parent.location
      ? window?.document?.referrer
      : window?.document?.location?.href

  let isPlanetIce = false
  if (parentUrl && parentUrl.includes('pacificadulthockey.com')) {
    isPlanetIce = true
  }
  return isCanlan ? canlanToken : isPlanetIce ? planetIceToken : carhaToken
}
